import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueCookies from "vue-cookies";

Vue.use(VueCookies);
Vue.use(Vuex);

// axios.interceptors.response.use(undefined, error => {
//   if (error.response.status === 401) {
//     let cookiesDomain = window.location.hostname;
//     VueCookies.remove("seller-token", null, cookiesDomain.replace("www", ""));
//     // if (VueCookies.isKey("seller-token")) {
//     //   VueCookies.remove("seller-token", null, `${process.env.WEB_HOST}`);
//     // }
//     window.location.href = "/";
//   }
//   return error;
// });

var chatTimePingPong;
const state = {
  sidebarShow: "responsive",
  sidebarMinimize: false,
  asideShow: false,
  darkMode: false,
  otherProfile: {
    id: 0,
    chatId: "",
  },
  menu: {
    order: 0,
    returnOrder: 0,
    review: 0,
    question: 0,
    refresh: true,
  },
  refreshMenu: null,
  isRefreshed: false,
  logoPathUrl: "",
  isFirstTime: true,
  profile: {
    email: "",
    firstname: "",
    lastname: "",
    displayNameTranslation: [
      { languageId: 1, name: "" },
      { languageId: 2, name: "" }
    ],
    statusId: 0,
    enabled: false,
    seller: {
      id: 0,
      name: "",
      logo: "",
      statusId: 0,
      enabled: false,
    }
  },

  //chat
  isSocketOpen: false,
  isLoadChatConversationList: false,
  isLoadChatMessageList: false,
};

const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarOpened ? false : "responsive";
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarClosed ? true : "responsive";
  },
  set(state, [variable, value]) {
    state[variable] = value;
  },
  toggle(state, variable) {
    Vue.set(state, variable, !state[variable]);
    // state[variable] = !state[variable]
  },
  setOtherProfile(state, val) {
    state.otherProfile = val;
  },
  setFirstTimeVisit(state, val) {
    state.isFirstTime = val;
  },
  getActiveMenuData(state, val) {
    if (state.menu !== val && !state.isRefreshed) {
      state.refreshMenu = null;
      setTimeout(() => {
        state.menu.order = val.order;
        state.menu.returnOrder = val.returnOrder;
        state.menu.review = val.review;
        state.menu.question = val.question;
        state.refreshMenu = true;
        state.isRefreshed = true;
      }, 0);
    } else {
      state.refreshMenu = false;
    }
  },
  setRefreshMenuData(state, val) {
    state.refreshMenu = val;
  },
  setRefreshed(state, val) {
    state.isRefreshed = val;
  },
  setLogoPathUrl(state, val) {
    state.logoPathUrl = val;
  },
  setShortProfile(state, val) {
    state.profile = val;
  },

  //chat
  setSocketOpen(state, val) {
    state.isSocketOpen = val;
  },
  setLoadChatConversationList(state, val) {
    state.isLoadChatConversationList = val;
  },
  setLoadChatMessageList(state, val) {
    state.isLoadChatMessageList = val;
  },
};

const actions = {
  getActiveData: ({ commit }) => {
    axios({
      url: `${Vue.prototype.$baseUrl}/api/Menu/ActiveMenu`,
      method: "get",
      headers: { ...Vue.prototype.$headers, sellerId: VueCookies.isKey("adminSellerId") ? VueCookies.get("adminSellerId") : 0, },
    }).then(response => {
      commit("getActiveMenuData", response.data.detail);
      commit("setRefreshed", false);
    });
  },
  handleChatSocket: ({ commit }, payLoad) => {
    commit("setSocketOpen", true);
    let pathConnection = `${Vue.prototype.$chatBaseUrlSocket}`;
    let socket = new WebSocket(pathConnection);
    let config = {
      action: "onRegister",
      brandId: payLoad.seller.id.toString(),
      userGUID: null,
    };
    socket.onopen = () => {
      socket.send(JSON.stringify(config));
      clearInterval(chatTimePingPong);
      chatTimePingPong = setInterval(() => {
        if (socket.readyState === socket.OPEN) {
          socket.send(JSON.stringify({ action: "ping" }));
        } else {
          clearInterval(chatTimePingPong);
          commit("setSocketOpen", false);
        }
      }, 15000);
    };

    socket.onmessage = event => {
      let messageRes = JSON.parse(event.data);
      if (messageRes.message == "pong") {
        return;
      }
      // console.log(JSON.parse(event.data));
      commit("setLoadChatConversationList", false);
      commit("setLoadChatMessageList", false);
      setTimeout(() => {
        commit("setLoadChatConversationList", true);
        commit("setLoadChatMessageList", true);
      }, 300);
    };
    socket.onerror = () => {
      clearInterval(chatTimePingPong);
      commit("setSocketOpen", false);
    };
    socket.onclose = () => {
      clearInterval(chatTimePingPong);
      commit("setSocketOpen", false);
    };
  },
  getUserApi: async ({ commit, rootGetters }, payload) => {
    if (VueCookies.isKey("seller-token")) {
      await axios({
        url: `${Vue.prototype.$baseUrl}/api/Profile/ShortProfile`,
        headers: { ...Vue.prototype.$headers, sellerId: VueCookies.isKey("adminSellerId") ? VueCookies.get("adminSellerId") : 0, },
        method: "get"
      }).then(res => {
        let data = res.data;
        if (data.result) {
          commit("setShortProfile", data.detail.userDetail);
        }
        // else {
        //   let cookiesDomain = window.location.hostname;
        //   VueCookies.remove("seller-token", null, cookiesDomain.replace("www", ""));
        //   // if (VueCookies.isKey("seller-token")) {
        //   //   VueCookies.remove("seller-token", null, `${process.env.WEB_HOST}`);
        //   // }
        //   commit("setShortProfile", false);
        // }
      });
    }
  },
};

const getters = {
  getRefreshMenu: state => {
    return state.refreshMenu;
  },
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
});
